<template>
  <div class="wrapper">
    <!-- 头部标题 -->
    <page-head title="复工统计" :showBack="false"></page-head>
    <div class="content">
      <Tabs>
        <TabPane label="分局统计">
          <iframe
            class="iframebox"
            :style="{height:height+'px'}"
            :src="head + url + '/workdept.cpt&communityId='+communityId"
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="门店统计">
          <iframe
            class="iframebox"
            :style="{height:height+'px'}"
            :src="head + url + '/workshop.cpt&communityId='+communityId"
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="员工统计">
          <iframe
            class="iframebox"
            :style="{height:height+'px'}"
            :src="head + url + '/workstaff.cpt&communityId='+communityId"
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="行业统计">
          <iframe
            class="iframebox"
            :style="{height:height+'px'}"
            :src="head + url + '/worktrade.cpt&communityId='+communityId"
            frameborder="0"
            scrolling="no"
          ></iframe>
        </TabPane>
        <TabPane label="企业复工统计">
          <!-- <iframe
            class="iframebox"
            :style="{height:height+'px'}"
            :src="head + url + '/scjdglj.cpt&communityId='+communityId"
            frameborder="0"
            scrolling="no"
          ></iframe> -->
          <market-chart></market-chart>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import pageHead from "../../components/head";
import marketChart from "./marketChart"
export default {
  name: "resumptionStatistic",
  components: {
    pageHead,
    marketChart
  },
  data() {
    return {
      communityId: this.$store.state.streetorcommunityid,
      url: "/decision/view/report?viewlet=/jczl",
      head:
        location.host.indexOf("localhost") > -1
          ? "http://yanfa.shequyun.cn"
          : "",
      height: ""
    };
  },
  mounted() {
    this.height = document.body.clientHeight - 60 - 90 - 40 - 30;
    console.log(this.head + this.url);
  }
};
</script>

<style lang="less" scoped>
/deep/ .ivu-tabs-nav .ivu-tabs-tab:hover {
  color: #ff7b44;
}
.wrapper {
  min-height: 100%;
  padding-bottom: 30px;
}
.content {
  margin: 0 20px;
}
.iframebox {
  width: 100%;
  background: #fff;
}
</style>
